import { format } from 'date-fns';

export const getFormattedTime = (seconds: number, formatType: string) => {
  const date = new Date(0, 0, 0, 0, 0, seconds);
  switch (formatType) {
    case 'h[h] mm[m]':
      return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`;
    case 'HH:mm':
      return format(date, 'HH:mm');
    case 'hh:mm:ss':
    default:
      return format(date, 'HH:mm:ss');
  }
};
